const bean = {
  bean: 'Bean',
  tips: '*Minimum beans for exchange: {{ num }}',
  dailyExchangeTimes: 'Daily exchange times:',
  dailyExchangeQuota: 'Daily exchange limit:',
  monthlyExchangeQuota: 'Monthly exchange limit:',
  confirmTitle: 'For Coin',
  confirmTips: 'Please check the amount you want to exchange (Bean Balance {{amount}})',
};

const coffee = {
  coffee: 'Coffee',
  tips: '*Minimum coffee for exchange: {{ num }}',
  dailyExchangeTimes: 'Daily exchange times:',
  dailyExchangeQuota: 'Daily exchange limit:',
  monthlyExchangeQuota: 'Monthly exchange limit:',
  confirmTitle: 'For Coin',
  confirmTips: 'Please check the amount you want to exchange (Coffee Balance {{amount}})',
};

const pearl = {
  pearl: 'Pearl',
  confirmTitle: 'For Coin',
  confirmTips: 'Please check the amount you want to exchange (Pearl Balance {{amount}})',
  amountTips: 'Minimum pearls for sending:{{ num }}',
};

export default {
  title: 'Exchange',
  enter: "Enter the recipient's account",
  exchanging: 'Exchanging...',
  rateBeanToCoin: '{{bean}} Bean = {{coin}} Coin',
  rateCoffeeToCoin: '{{coffee}} ml = {{coin}} Coin',
  success: 'Exchange successful',
  successTips: 'Please check the amount you have exchanged',
  failure: 'Warning',
  failureTips:
    'The current transaction is abnormal, please go to the transaction details to verify the result',
  minNum: 'Must be ≥ {{num}} beans every time',
  bean,
  pearl,
  coffee,
};
